// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lsir","comment":"styles_comment__2j4pW"};